import script from "./ResourcesHomeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourcesHomeView.vue?vue&type=script&lang=ts&setup=true"

import "./ResourcesHomeView.vue?vue&type=style&index=0&id=e1b703ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1b703ca"]])

export default __exports__